import { defineNamespace, ConsumerTypes, ApiVersions } from '../../common';
import {
  platformAPICreator as platformAPICreatorV2Blocks,
  IPlatformAPIDefinition as IPlatformAPIBlocksV2Definition,
} from './refComponents.panel-builder.v2';

export * from './refComponents.super';

export type INamespaceDefinition = IPlatformAPIBlocksV2Definition;

export const namespaceCreator = defineNamespace<INamespaceDefinition>(
  (config) => {
    if (
      config.consumerType === ConsumerTypes.PanelBuilder &&
      config.version === ApiVersions.V2
    ) {
      return platformAPICreatorV2Blocks(config.superAPI)(config.context);
    }

    return null;
  },
);
